import { motion } from "framer-motion";
import { Shield } from "lucide-react";

const ChiappellaGarantia = () => {
  return (
    <section
      id="garantia"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(217 61% 8%), hsl(215 48% 14%))",
      }}
    >
      <div className="container px-4 max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="rounded-3xl border border-white/10 p-8 md:p-14 text-center"
          style={{
            background:
              "linear-gradient(135deg, hsl(220 69% 4%), hsl(217 61% 8%))",
          }}
        >
          {/* Shield icon */}
          <div className="flex justify-center mb-8">
            <div
              className="w-20 h-20 md:w-24 md:h-24 rounded-2xl flex items-center justify-center"
              style={{
                background: "linear-gradient(135deg, #1d4a8c, #7ab7fd)",
                boxShadow: "0 18px 50px -12px rgba(122,183,253,0.55)",
              }}
            >
              <Shield className="w-10 h-10 md:w-12 md:h-12 text-white" strokeWidth={2} />
            </div>
          </div>

          {/* Badge */}
          <span
            className="text-sm font-semibold tracking-[0.25em] uppercase mb-4 block"
            style={{ color: "#7ab7fd" }}
          >
            Garantía Coressen®
          </span>

          {/* Title */}
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-[1.1] mb-8">
            Coherencia estratégica
            <br />
            <span style={{ color: "#7ab7fd" }}>garantizada.</span>
          </h2>

          {/* Body */}
          <div className="space-y-5 text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
            <p>
              Garantizamos coherencia estratégica entre las tres unidades de
              marca y su holding.
            </p>
            <p>
              Si alguna definición de identidad, posicionamiento o narrativa no
              refleja el nivel real de la institución o su potencial de
              crecimiento, se ajusta dentro del proceso sin costo adicional
              hasta lograr alineación total.
            </p>
            <p className="font-display italic text-lg md:text-xl" style={{ color: "#7ab7fd" }}>
              No entregamos piezas. Entregamos sistemas que funcionan.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ChiappellaGarantia;
